import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import localize, { LocKeys } from "../../constants/localizations";
import CustomSnackbar from "../../shared/CustomSnackbar/CustomSnackbar";
import { clearBuildingRequestState } from "../../actions";
import { alertTypeConstants } from "../../constants/constants";
import ReactMarkdown from "react-markdown";

/**
 * Snackbar messages for BUILDING actions
 * @param {*} props
 * @returns
 */
const BuildingRequestPopups = (props) => {
	const {
		customSuccessMessage = "",
		customErrorMessage = "",
		// Actions
		clearBuildingRequestState,
		// From state
		request,
		action,
		errorMessage,
		successMessage,
	} = props;

	const [showError, setShowError] = useState(!action && request);
	const [showSuccess, setShowSuccess] = useState(action && request);

	useEffect(() => {
		if (request) {
			if (!action) {
				setShowError(true);
			} else {
				setShowSuccess(true);
			}
		}
	}, [action, request]);

	const errorOnClose = () => {
		setShowError(false);
		clearBuildingRequestState();
	};

	const successOnClose = () => {
		setShowSuccess(false);
		clearBuildingRequestState();
	};

	return (
		<>
			<CustomSnackbar
				open={showSuccess}
				onClose={successOnClose}
				title={localize(LocKeys.SUCCESS)}
			>
				<ReactMarkdown
					children={(successMessage || customSuccessMessage).replaceAll(
						"\n",
						"  \n"
					)}
				/>
			</CustomSnackbar>
			<CustomSnackbar
				open={showError}
				onClose={errorOnClose}
				type={alertTypeConstants.ERROR}
				title={localize(LocKeys.ERROR)}
			>
				<ReactMarkdown
					children={(errorMessage || customErrorMessage).replaceAll(
						"\n",
						"  \n"
					)}
				/>
			</CustomSnackbar>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		action: state.getIn(["building", "action"]),
		request: state.getIn(["building", "request"]),
		errorMessage: state.getIn(["building", "errorMessage"]),
		successMessage: state.getIn(["building", "successMessage"]),
	};
};
export default connect(mapStateToProps, {
	clearBuildingRequestState,
})(BuildingRequestPopups);
